import React from 'react'
import AdminLayout from './components/AdminLayout'
import "./styles/AdminTopbar.css"
import "./styles/AdminSidebar.css";
import './styles/CreateTicketPage.css'
import "./styles/AgentWorkSpace.css"
import "./styles/TicketsPage.css"
import "./styles/TicketDetail.css"
import "./styles/Vehicle360Page.css"

export default function AdminDashboard({ currentUser, fetchJson, onLogout, onBack }) {
  return (
    <div>
        <AdminLayout currentUser={currentUser} fetchJson={fetchJson} onLogout={onLogout} onBack={onBack} />
    </div>
  )
}
